import React, { useState } from "react";
import "./Actualites.css";

export default function Actualites() {

  const [openIndex, setOpenIndex] = useState(null);

  const newsData = [
    {
      date: "vendredi, 21 août 2015 par Demnaty",
      title: "Enthusiastically administrate ubiquitous",
      description:
        "Nous adoptons les plus hauts standards de service client, soutenus par des solutions digitales performantes et une vision innovante axée sur la créativité et l’amélioration continue.Nous optimisons constamment nos processus afin d’apporter une réelle valeur ajoutée à nos clients et de garantir des résultats durables.En accompagnant la transformation digitale, nous mettons en place des stratégies efficaces favorisant la croissance et le succès à long terme.",
      image: "/image/office team.jpg",
    },
    {
      date: "vendredi, 07 août 2015 par Demnaty",
      title: "Uniquely productize next-generation opportunities",
      description:
        "Nous travaillons de manière innovante et durable, 24h/24, pour offrir un service client de qualité reposant sur des informations essentielles et une expertise spécialisée, tout en facilitant les opportunités à l’échelle de l’entreprise, même en période de défis ou de crise. Nous nous concentrons sur l’amélioration des processus et des services numériques précis plutôt que de nous limiter aux méthodes traditionnelles, tout en renforçant les compétences et les missions essentielles, en développant les méthodes de travail existantes et en personnalisant les services numériques de manière organisée et facile à maintenir. Nous nous engageons également à découvrir de nouvelles opportunités et à diffuser la valeur ajoutée via des systèmes flexibles et des portails intelligents, en reliant tous les services et systèmes de manière intégrée afin d’assurer une expérience fluide et efficace pour les clients et partenaires, tout en transformant les processus de manière continue et flexible pour optimiser l’utilisation des ressources et expertises disponibles, avec un engagement constant envers l’excellence et la qualité pour garantir le succès durable de l’entreprise et de ses partenaires.",
      image: "/image/image69.jpg",
    },
    {
      date: "vendredi, 07 août 2015 par Demnaty",
      title: "Dramatically integrate viral technologies",
      description:
        "Nous coordonnons de manière intégrée les éléments qualitatifs innovants à travers les médias et exploitons les réseaux dynamiques pour renforcer le capital humain des entreprises, tout en gérant efficacement les marchés fragmentés et les plateformes dynamiques. Nous consolidons les réseaux orientés marché pour renforcer les compétences de base, soutenons les produits maintenables via le capital intellectuel, simplifions les modèles avancés et tirons parti des scénarios révolutionnaires grâce à la collaboration et au partage d’idées. Nous développons les ressources à valeur ajoutée via des chaînes d’approvisionnement flexibles, réorganisons les opérations multi-plateformes pour garantir une performance optimale, tout en favorisant l’innovation au sein des équipes et en maximisant les fonctionnalités B2C pour les réseaux multi-unités.",
      image: "/image/Working girl.jpg",
    },
  ];

  const toggleText = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      {/* ================= HERO SECTION ================= */}
      <section className="packs-hero">
        <video
          className="packs-hero-video"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/image/video.mp4" type="video/mp4" />
        </video>

        <div className="packs-hero-overlay"></div>

        <div className="packs-hero-content">
          <h1 className="packs-hero-title">Actualités</h1>
          <p className="packs-hero-description">
            Restez informés de nos dernières réalisations <br />
            et nouveautés.
          </p>
        </div>

        <div className="packs-hero-wave">
          <svg viewBox="0 0 1440 200" preserveAspectRatio="none">
            <path
              d="M0,160 C360,80 1080,240 1440,120 L1440,200 L0,200 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </section>

      {/* ================= NEWS SECTION ================= */}
      <section className="news-section">
        <div className="news-container">
          {newsData.map((news, idx) => (
            <article key={idx} className="news-card">
              <img
                src={news.image}
                alt={news.title}
                className="news-image"
              />
              <div className="news-content">
                <p className="news-date">{news.date}</p>
                <h3 className="news-title">{news.title}</h3>

                <p className="news-description">
                  {openIndex === idx
                    ? news.description
                    : news.description.substring(0, 80) + "..."}
                </p>

                <button
                  className="news-button"
                  onClick={() => toggleText(idx)}
                >
                  {openIndex === idx ? "Réduire" : "Lire plus ›"}
                </button>
              </div>
            </article>
          ))}
        </div>
      </section>
    </>
  );
}
